import { render, staticRenderFns } from "./onlineTrainingHome.vue?vue&type=template&id=b611580a&scoped=true&"
import script from "./onlineTrainingHome.vue?vue&type=script&lang=js&"
export * from "./onlineTrainingHome.vue?vue&type=script&lang=js&"
import style0 from "./onlineTrainingHome.vue?vue&type=style&index=0&id=b611580a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b611580a",
  null
  
)

export default component.exports